import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import { CustomTooltip } from "src/components/CustomTooltip";
import styles from "./Tooltip.module.css";

export const ComparisonTooltipModule: TooltipContentModule = {
  type: "comparison",
  priority: 2,
  shouldRender: (context: TooltipContext) => {
    return (
      context.type === "comparison" && !!context.metadata?.comparisonValues
    );
  },
  render: (context: TooltipContext) => {
    const { from, to, delta, percentage } = context.metadata.comparisonValues;

    const content = (
      <div className={styles.tooltipContainer}>
        <div className={styles.tooltipHeader}>Comparison</div>
        <div className={styles.tooltipSection}>
          <div className={styles.tooltipRow}>
            <span>Previous Value</span>
            <span className={styles.tooltipValue}>{from}</span>
          </div>
          <div className={styles.tooltipRow}>
            <span>Current Value</span>
            <span className={styles.tooltipValue}>{to}</span>
          </div>
          <div className={styles.tooltipDivider} />
          <div className={styles.tooltipRow}>
            <span>Change</span>
            <span className={styles.tooltipValue}>{delta}</span>
          </div>
          {percentage !== undefined && (
            <div className={styles.tooltipRow}>
              <span>Change %</span>
              <span className={styles.tooltipValue}>{percentage}</span>
            </div>
          )}
        </div>
      </div>
    );

    return (
      <CustomTooltip content={content} placement="left">
        {context.children}
      </CustomTooltip>
    );
  },
};
